export default {
      id: "icon--flame-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--flame-usage",
      toString: function () {
        return this.url;
      }
    }